import { ReactNode } from 'react';
import { ArrowLeft } from 'lucide-react';

import { Button } from '@/components/ui/button';

export interface EditorHeaderProps {
  /** The record's name, or "New …" while creating. */
  title: string;
  /** One line under the title saying what the page edits. */
  description?: ReactNode;
  /** Back to the list (also in the breadcrumbs, which hide below md). */
  onBack?: () => void;
  backLabel?: string;
}

/**
 * The heading of a catalog editor (product family, product type): a back arrow,
 * its name and what it edits. Passed to `AdminPage` as `header`; Save and
 * Discard live in the kit's `SaveBar` at the bottom, like every admin editor.
 */
export function EditorHeader({ title, description, onBack, backLabel }: EditorHeaderProps) {
  return (
    <div className="flex min-w-0 items-start gap-2" data-testid="editor-header">
      {onBack && (
        <Button
          variant="ghost"
          size="icon-sm"
          className="-ms-1.5 mt-0.5 text-muted-foreground"
          onClick={onBack}
          aria-label={backLabel}
        >
          <ArrowLeft className="rtl:rotate-180" />
        </Button>
      )}
      <div className="min-w-0">
        <h1 className="min-w-0 truncate font-heading text-2xl font-medium tracking-tight">{title}</h1>
        {description && <p className="mt-1 max-w-2xl text-sm text-muted-foreground">{description}</p>}
      </div>
    </div>
  );
}
